import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font, radius } from '~styles/theme.stylex';

// Shapes mirror the Flutter theme (lib/theme.dart): buttonRadius=12 →
// radius.md on buttons and inputs, inputs filled with surfaceDim, the submit
// styled like AppCta (the web port of the app's ElevatedButton), tabs like
// the app's TabBar (primary label + indicator over a hairline divider).
export const styles = {
  login: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  modeRow: {
    display: "x78zum5",
    borderBottomWidth: "xso031l",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "xbuxeer",
    $$css: true
  },
  modeTab: {
    flexGrow: "x1iyjqo2",
    paddingBlock: "x13eudtd",
    paddingTop: null,
    paddingBottom: null,
    backgroundColor: "xjbqb8w",
    color: "xarw3lm",
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomWidth: "xlxy82",
    borderBottomStyle: "x1q0q8m5",
    borderBottomColor: "x16stqrj",
    marginBottom: "x1jyxor1",
    fontFamily: "x1qh5nd4",
    fontSize: "x6u19be",
    fontWeight: "xr323w7",
    cursor: "x1ypdohk",
    $$css: true
  },
  modeTabActive: {
    color: "x1gonuu0",
    borderBottomColor: "x1jrf0mz",
    fontWeight: "xlr2uoh",
    $$css: true
  },
  form: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x8233eu",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  label: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "xpj7pl4",
    rowGap: null,
    columnGap: null,
    textAlign: "xdpxx8g",
    fontSize: "x1dcheo9",
    fontWeight: "xr323w7",
    color: "xarw3lm",
    $$css: true
  },
  input: {
    paddingBlock: "xo0yzjp",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "x13s4r1c",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    backgroundColor: "xn1aht2",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x2rc37l x12mq7fu",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "xnwxjz0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    fontFamily: "x1qh5nd4",
    fontSize: "x1jchvi3",
    color: "xtt1gjl",
    outline: "x1uvtmcs",
    outlineColor: null,
    outlineOffset: null,
    outlineStyle: null,
    outlineWidth: null,
    $$css: true
  },
  submit: {
    paddingBlock: "x142x9wm",
    paddingTop: null,
    paddingBottom: null,
    backgroundColor: "xwk94rn",
    color: "x6n9e3r",
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderRadius: "xnwxjz0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    boxShadow: "x129li60",
    fontFamily: "x1qh5nd4",
    fontSize: "x1lkfr7t",
    fontWeight: "xlr2uoh",
    cursor: "x1ypdohk",
    opacity: "xfqoyci",
    $$css: true
  },
  linkButton: {
    alignSelf: "xamitd3",
    backgroundColor: "xjbqb8w",
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    color: "xarw3lm",
    fontFamily: "x1qh5nd4",
    fontSize: "x1dcheo9",
    textDecorationLine: "xujl8zx",
    cursor: "x1ypdohk",
    $$css: true
  },
  hint: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x1dcheo9",
    color: "xarw3lm",
    lineHeight: "x1evy7pa",
    $$css: true
  }
};